"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIframe = void 0;

var _loader = require("./loader");

var createIframe = function createIframe(src) {
  var iframe = document.createElement("iframe");
  iframe.style.setProperty("width", "100%");
  iframe.style.setProperty("height", "100%");
  iframe.style.setProperty("border", "none");
  iframe.src = src;
  return (0, _loader.wrapWithLoader)(iframe);
};

exports.createIframe = createIframe;